import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './component/app/app.component';
import { BodyComponent } from './component/body/body.component';
import { ControlMenuComponent } from './component/control-menu/control-menu.component';
import { TitleBarComponent } from './component/title-bar/title-bar.component';
import { OptionsMenuComponent } from './component/options-menu/options-menu.component';
import { NavButtonComponent } from './component/nav-button/nav-button.component';
import { CanvasComponent } from './component/canvas/canvas.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { RoofFormComponent } from './component/roof-form/roof-form.component';
import { MatFormFieldModule, MatSelectModule, MatOptionModule, MatCheckboxModule, MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ZonesListComponent } from './component/zones-list/zones-list.component';
import { ProductsComponent } from './component/products/products.component';
import { HttpClientModule } from '@angular/common/http';
import { LayerControlComponent } from './component/layer-control/layer-control.component';
import { HelperMainComponent } from './component/helper-main/helper-main.component';
import { HelperZonesComponent } from './component/helper-zones/helper-zones.component';


@NgModule({
  declarations: [
    AppComponent,
    BodyComponent,
    ControlMenuComponent,
    TitleBarComponent,
    OptionsMenuComponent,
    NavButtonComponent,
    CanvasComponent,
    RoofFormComponent,
    ZonesListComponent,
    ProductsComponent,
    LayerControlComponent,
    HelperMainComponent,
    HelperZonesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatCheckboxModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCy_3obhzGEVgUWIVKZnmhkyjL9UKKy90M'
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
